module.exports = __webpack_public_path__ + "img/transfer_infographic.9c5f4ca6.svg";